"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActivityParticipantStatus = void 0;
var ActivityParticipantStatus = /*#__PURE__*/function (ActivityParticipantStatus) {
  ActivityParticipantStatus["NEW"] = "new";
  ActivityParticipantStatus["WAITING_LIST"] = "waiting-list";
  ActivityParticipantStatus["PAYMENT_IN_PROGRESS"] = "payment-in-progress";
  ActivityParticipantStatus["REGISTRATION_IN_PROGRESS"] = "registration-in-progress";
  ActivityParticipantStatus["APPROVAL_PENDING"] = "approval-pending";
  ActivityParticipantStatus["REGISTERED"] = "registered";
  ActivityParticipantStatus["ARRIVED"] = "arrived";
  ActivityParticipantStatus["NO_SHOW"] = "no-show";
  return ActivityParticipantStatus;
}(ActivityParticipantStatus || (exports.ActivityParticipantStatus = ActivityParticipantStatus = {}));

